import { useEffect, useLayoutEffect, useRef } from 'react'

// 다이얼로그/드로어 소프트 포커스 관리(하드 트랩 없음 — 중첩 body-portal 팝업 보존).
// 열림 직전 포커스를 저장하고 닫힘 시 그 요소로 복원한다.
// - 저장: useLayoutEffect(열림 커밋) 에서 document.activeElement 캡처 →
//   Radix FocusScope 의 autofocus(useEffect, 이후 실행)보다 먼저 실행돼 트리거를 잡는다.
// - 복원: 닫힘 커밋 후 저장 요소로 focus.
export function useFocusRestore(open: boolean): void {
  const restoreRef = useRef<HTMLElement | null>(null)
  // false 로 시작 → 이미 열린 상태로 마운트되는 다이얼로그({open && <Dialog open/>})도 opener 캡처.
  const prevOpen = useRef(false)

  useLayoutEffect(() => {
    if (open && !prevOpen.current) {
      restoreRef.current = (document.activeElement as HTMLElement | null) ?? null
    }
  }, [open])

  useEffect(() => {
    if (prevOpen.current && !open) {
      const el = restoreRef.current
      restoreRef.current = null
      // 복원 조건: (a) 저장 요소가 아직 문서에 있고 (b) 닫힘 후 포커스가 유실 상태(body/null)일 때만.
      //   소비처가 닫힘 시 의도적으로 다른 곳에 포커스를 옮겼다면(active≠body) 되뺏지 않는다.
      const active = document.activeElement
      const focusLost = active == null || active === document.body
      if (el != null && el.isConnected && focusLost) el.focus()
    }
    prevOpen.current = open
  }, [open])
}
